const config = {
	api: {
		idm: {
			baseUrl: 'https://idm-stage.ax-semantics.com/v1/'
		},
	},
	auth: {
		clientID: 'AJqKziTZloFiAkexBwkX5AqXUnr35Gbu',
		domain: 'ax-semantics-stage.eu.auth0.com'
	},
	cockpit: {
		baseUrl: 'https://cockpit.test.qax.io/',
	},
}

export default config
